import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';

/**
 * Route `data`:
 * - `permissions`: une permission ou un tableau (selon `permissionMode`)
 * - `permissionMode`: `'any'` (défaut) ou `'all'`
 */
export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  auth.authenticated();

  const raw = route.data['permissions'] as string | string[] | undefined | null;
  if (raw === undefined || raw === null) {
    return true;
  }

  const list = (Array.isArray(raw) ? raw : [raw]).filter(Boolean);
  if (list.length === 0) {
    return true;
  }

  const mode = (route.data['permissionMode'] as 'all' | 'any') || 'any';

  if (auth.hasPermission(list, mode)) {
    return true;
  }

  router.navigate(['/acces-refuse']);
  return false;
};
